<style lang="scss" type="stylesheet/scss" scoped>
.container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("../images/page1-bg-1.png") no-repeat;
  font-size: 0;
  height: 100vh;
  position: relative;
  &.default {
    &:after {
      content: "";
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100px;
      background: url("../images/page1-bg-bottom-0.png") left bottom no-repeat;
      background-size: 100% auto;
    }
  }
  &.active {
    &:after {
      content: "";
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100px;
      background: url("../images/page1-bg-bottom-1.png") left bottom no-repeat;
      background-size: 100% auto;
    }
  }
  .question {
    position: absolute;
    right: 0;
    top: 220px;
    img {
      height: 80px;
    }
  }

  .header {
    .left {
      position: absolute;
      left: 183px;
      top: 50px;
    }
    .right {
      position: absolute;
      left: 375px;
      top: 50px;
    }
  }
}

.content {
  display: flex;
  .items-warpper {
    display: flex;
    flex-direction: column;
    padding-top: 300px;
    height: calc(100vh - 100px);
    box-sizing: border-box;
    width: 50%;
    text-align: center;
    .items {
      flex: 1;
      height: 0;
      position: relative;
      .children {
        display: flex;
        text-align: center;
        position: relative;
        height: calc((100vh - 400px) / 7) !important;
        &.index4 {
          padding-left: 100px;
          @media only screen and (min-height: 1327px) {
            padding-left: 80px;
          }

          @media only screen and (min-height: 1448px) {
            padding-left: 68px;
            #right-10,
            #right-4 {
              height: 105px;
            }
            #right-5,
            #right-2 {
              height: 105px;
            }
          }

          .items-children {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            &:first-child {
              margin-right: 10px;
              .plus {
                left: 30px;
              }
            }
            &:last-child {
              .plus {
                left: unset;
                right: 30px !important;
              }
            }
          }

          .bottom {
            font-size: 2vw;
          }
        }
        &.index5 {
          padding-left: 100px;
          @media only screen and (min-height: 1327px) {
            padding-left: 80px;
          }

          @media only screen and (min-height: 1448px) {
            padding-left: 68px;
            #right-6 {
              height: 105px;
            }
            #right-7 {
              height: 105px;
            }
          }
          .items-children {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            &:first-child {
              margin-right: 10px;
              .plus {
                left: 30px;
              }
            }
            &:last-child {
              .plus {
                left: unset;
                right: 30px !important;
              }
            }
          }

          .bottom {
            font-size: 1.75vw;
          }
        }
      }
      .children:last-child {
        &.index6 {
          padding-left: 100px;
          @media only screen and (min-height: 1327px) {
            padding-left: 80px;
          }

          @media only screen and (min-height: 1448px) {
            padding-left: 68px;
            #right-8 {
              height: 105px;
            }
            #right-9 {
              height: 105px;
            }
          }

          .items-children {
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            &:first-child {
              margin-right: 10px;
              .plus {
                left: 30px;
              }
            }
            &:last-child {
              .plus {
                left: unset;
                right: 30px !important;
              }
            }
          }

          .bottom {
            font-size: 2vw;
          }
        }
      }
      .image-warpper {
        // position: relative;
        .image-label {
          position: absolute;
          top: 0;
          right: calc(50% - 128px);
          width: 96px;
        }
        .dump-image {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          display: block;
          margin: 0 auto;
          height: calc((100vh - 400px) / 7 - 30px);
          opacity: 0;
          &.show {
            opacity: 1;
          }
        }
        .image {
          position: relative;
          height: calc((100vh - 400px) / 7 - 30px);
        }
      }
      .bottom {
        font-size: 2.5vw;
        line-height: 20px;
      }
      .plus {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .left-warpper {
    .left-item {
      .bottom {
        color: white;
      }
      .plus {
        right: 30px;
      }
    }
  }
  .right-warpper {
    .right-item {
      .bottom {
        color: #89161c;
      }
      .plus {
        left: 30px;
      }
    }
  }
}

.dump {
  .rightdump-items,
  .leftdump-items {
    position: fixed;
    img {
      width: 90%;
    }
  }
}

.btn {
  position: absolute;
  bottom: 10px;
  left: 50%;
  margin-left: -109px;
  z-index: 1;
}

.container2 {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: url("../images/page2-bottom.png") left bottom no-repeat,
    url("../images/page2-bg-1.png") no-repeat;
  background-size: 100% auto;
  font-size: 0;
  height: 100vh;
  padding-top: 10px;
  padding-bottom: 200px;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .top {
    margin-bottom: 50px;
    position: relative;
    text-align: center;
    img {
      width: 80%;
      @media only screen and (min-height: 1288px) {
        width: 100%;
      }
    }
    .img {
      width: 210px;
      height: 210px;
      position: absolute;
      top: 108px;
      @media only screen and (min-height: 1288px) {
        top: 165px;
      }
      &.left {
        left: 65px;
        @media only screen and (min-height: 1288px) {
          left: 30px;
        }
      }
      &.right {
        right: 55px;
        @media only screen and (min-height: 1288px) {
          right: 35px;
        }
      }
    }
  }
  .content {
    img {
      width: 100%;
    }
  }
  .save {
    margin-top: 20px;
  }
  .back {
    margin-top: 40px;
    @media only screen and (min-height: 1288px) {
      margin-top: 40px;
    }
  }
  .txt {
    font-family: "NotoSansSC" !important;
    font-size: 1.2vh;
    line-height: 1.25;
    @media only screen and (min-height: 1288px) {
      font-size: 1vh;
    }
    color: black;
    position: absolute;
    bottom: 45px;
    width: 680px;
    left: 35px;
  }
}

/*弹出层*/
.popup {
  position: fixed;
  background: rgba(0, 0, 0, 0.7) !important;
  width: 100%;
  height: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .popup-border {
    width: 80%;
  }
}
</style>

<template>
  <div class="hello">
    <loading></loading>

    <!--弹出层-->
    <div v-show="popup" class="popup">
      <img
        @click="popup = false"
        class="popup-border"
        src="../images/tips-layer.png"
        alt
      />
    </div>

    <div
      class="container"
      v-show="activeIndex === 0"
      :class="showBtn ? 'active' : 'default'"
    >
      <div class="header">
        <div class="left">
          <img
            src="../images/white-number.png"
            class="number"
            v-show="!dumpLeftImgs.length"
          />
        </div>
        <div class="right">
          <img
            src="../images/red-number.png"
            class="number"
            v-show="!dumpRightImgs.length"
          />
        </div>
      </div>
      <div v-show="!showBtn" class="question" @click="popup = true">
        <img src="../images/tips.jpg" alt />
      </div>

      <div class="content">
        <div class="items-warpper left-warpper">
          <div
            class="left-item items"
            @click="dumpLeftItem(item, index)"
            v-for="(item, index) in leftProducts"
          >
            <div class="top">
              <div class="image-warpper">
                <img :src="item.label" alt="" class="image-label" />
                <img :src="item.src" :id="'left-' + index" class="image" />
              </div>
              <img src="../images/add-white.png" class="plus" />
            </div>
            <div class="bottom">{{ item.name }}</div>
          </div>
        </div>
        <div class="items-warpper right-warpper">
          <div
            class="right-item items"
            @click="dumpRightItem(item)"
            v-for="(item, index) in rightProducts"
          >
            <div
              v-if="item.children.length"
              class="children"
              :class="{
                index4: index === 4 || index === 2,
                index5: index === 5,
                index6: index === 6,
              }"
            >
              <div
                class="items-children"
                @click.stop="dumpRightItem(i)"
                v-for="(i, idx) in item.children"
              >
                <div class="top">
                  <div class="image-warpper">
                    <img :src="i.label" alt="" class="image-label" style="right: calc(75% - 128px);" />
                    <img :src="i.src" :id="'right-' + i.index" class="image" />
                  </div>
                </div>
                <img src="../images/add-red.png" class="plus" />
                <div class="bottom">{{ i.name }}</div>
              </div>
            </div>
            <div v-if="!item.children.length">
              <div class="top">
                <div class="image-warpper">
                  <img :src="item.label" alt="" class="image-label" />
                  <img
                    :src="item.src"
                    :id="'right-' + item.index"
                    class="image"
                  />
                  <img
                    :src="item.src"
                    :class="{ show: item.show }"
                    class="dump-image"
                  />
                </div>
              </div>
              <img src="../images/add-red.png" class="plus" />
              <div class="bottom">{{ item.name }}</div>
            </div>
          </div>
        </div>

        <div class="btn" v-show="showBtn" @click="trigglerPage">
          <img src="../images/btn.png" />
        </div>
      </div>

      <div class="dump">
        <div
          class="leftdump-items"
          :id="'leftdump-' + index"
          v-for="(item, index) in dumpLeftImgs"
        >
          <img :src="item" />
        </div>
        <div
          class="rightdump-items"
          :id="'rightdump-' + index"
          v-for="(item, index) in dumpRightImgs"
        >
          <img :src="item" />
        </div>
      </div>
    </div>

    <div class="container2" v-show="activeIndex === 1">
      <div class="top">
        <img src="../images/page2-top.png" />
        <!-- <img v-else src="../images/page2-top-14.png" alt /> -->
        <img :src="dumpLeftImgs[0]" class="left img" />
        <img :src="dumpRightImgs[0]" class="right img" />
      </div>
      <div class="content">
        <img :src="require('../images/$' + price + '.png')" />
      </div>
      <div class="save" v-if="price">
        <img src="../images/save.png" />
      </div>
      <div class="back" @click="trigglerPage">
        <img src="../images/back.png" />
      </div>
      <!-- <div class="txt">
        随心配“1+1=12”是把从上述红区任意一款指定产品搭配上述白区任意一款指定产品，一般为12元，个别需加价购。
        红区中产品包含“双 层黑椒牛肉堡（1个）、麦乐鸡®（5块）、双层吉士汉堡、麦香鸡、那么大鸡排（1份）、薯条（小）”，
        白区中产品包含“派（香芋/菠萝）（1块），迷你新地（草莓/朱古力）（1杯）、汽水（可口可乐/零度可口可乐/雪碧）（1杯）、
        锡兰红茶（1杯）、热带果果气泡饮（1杯）”， 其中选择热带果果气泡饮需另加2元。食品及包装以实物为准，图片仅供参考。
        鳕鱼金砖中的鳕鱼源自鳕形目下的狭鳕鱼或无须鳕鱼。热带 果果气泡饮含微量酒精和果肉。上述产品自2020年9月5日至2020年9月29日，
        在中国（本活动场景下不包括港澳台地区）部分麦当劳®餐 厅售卖，机场、火车站等交通枢纽餐厅、旅游景区餐厅等特殊餐厅除外，
        具体以餐厅公示为准。以上组合仅限早餐时段后供应，早餐供应时 间以餐厅实际为准，至上午10：30结束。通过麦乐送®送餐服务、
        麦当劳APP、微信小程序、自助点餐机、第三方外送平台等渠道点餐的，优惠活动参与情况以各自渠道的图示宣传为准。
        除食物外，其他物品（包括容器）不在售卖范围之内。“Coca-Cola”「可口可乐」、“Sprite”、「雪碧」、弧形瓶是可口可乐的商标。

        &lt;!&ndash;   以上组合仅限早餐时段后供应，早餐供应时间以餐厅实际为准，至上午10:30结束。通过麦乐送®送餐服务、
           麦当劳APP、微信小程序、自助点餐机、第三方外送平台等渠道点餐的，优惠活动参与情况以各自渠道的图示宣传为准。
           图中所示节省的价格，是指购买套餐/组合的价格，与单独购买其中所含单品的单买价总和相比节省的价格。&ndash;&gt;
      </div>-->
    </div>
  </div>
</template>

<script>
import loading from "./loading";
export default {
  components: { loading },
  data() {
    return {
      activeIndex: 0,
      dumpLeftImgs: [],
      dumpLeftIndex: [],
      dumpRightImgs: [],
      dumpRightIndex: [],
      rightIndex: "",
      popup: false,

      leftProducts: [
        {
          index: 0,
          name: "大丸子汉堡",
          src: require("../products/l-1.png"),
          children: [],
          price: 16,
          label: require("../assets/new-white.png"),
        },
        {
          index: 1,
          name: "双层吉士汉堡",
          src: require("../products/l-2.png"),
          children: [],
          price: 18,
          label: require("../assets/classic-white.png"),
        },
        {
          index: 2,
          name: "鳕鱼金砖",
          src: require("../products/l-3.png"),
          children: [],
          price: 10,
          label: require("../assets/new-white.png"),
        },
        {
          index: 3,
          name: "小薯条",
          src: require("../products/l-4.png"),
          children: [],
          price: 8,
        },
        {
          index: 4,
          name: "麦乐鸡（5块）",
          src: require("../products/l-5.png"),
          children: [],
          price: 11.5,
        },
        {
          index: 5,
          name: "那么大鸡排",
          src: require("../products/l-6.png"),
          children: [],
          price: 12,
        },
        {
          index: 6,
          name: "麦香鸡",
          src: require("../products/l-7.png"),
          children: [],
          price: 14,
        },
      ],
      rightProducts: [
        {
          index: 0,
          name: "黑黑好巧三角派",
          src: require("../products/r-1.png"),
          children: [],
          price: 8,
          label: require("../assets/new-red.png"),
        },
        // {
        //   children: [
        //     {
        //       index: 4,
        //       name: "黑黑好巧三角派",
        //       src: require("../products/r-1.png"),
        //       price: 8,
        //     },
        //     {
        //       index: 5,
        //       name: "英式热奶茶",
        //       src: require("../products/r-6.png"),
        //       price: 11,
        //     },
        //   ],
        // },
        {
          index: 1,
          name: "FUZE Tea 低糖茉莉绿茶（中杯）",
          src: require("../products/r-2.png"),
          children: [],
          price: 12,
        },
        {
          children: [
            {
              index: 10,
              name: "英式热奶茶",
              src: require("../products/r-11.png"),
              price: 11,
              label: require("../assets/new-red.png"),
            },
            {
              index: 2,
              name: "锡兰红茶",
              src: require("../products/r-3.png"),
              children: [],
              price: 10.5,
            },
          ],
        },
        // {
        //   index: 2,
        //   name: "锡兰红茶",
        //   src: require("../products/r-3.png"),
        //   children: [],
        //   price: 10.5,
        // },
        {
          index: 3,
          name: "雪碧（中杯）",
          src: require("../products/r-4.png"),
          children: [],
          price: 9.5,
        },
        {
          children: [
            {
              index: 4,
              name: "可乐（中杯）",
              src: require("../products/r-5.png"),
              price: 9.5,
            },
            {
              index: 5,
              name: "零度可乐（中杯）",
              src: require("../products/r-6.png"),
              price: 9.5,
            },
          ],
        },
        {
          children: [
            {
              index: 6,
              name: "草莓口味迷你新地",
              src: require("../products/r-7.png"),
              price: -999,
            },
            {
              name: "朱古力口味迷你新地",
              index: 7,
              src: require("../products/r-8.png"),
              price: -999,
            },
          ],
        },
        {
          children: [
            {
              index: 8,
              name: "香芋派",
              src: require("../products/r-9.png"),
              price: 7,
            },
            {
              name: "菠萝派",
              index: 9,
              src: require("../products/r-10.png"),
              price: 7,
            },
          ],
        },
      ],
    };
  },
  computed: {
    showBtn() {
      return this.dumpLeftImgs.length && this.dumpRightImgs.length;
    },
    price() {
      // console.log(this.dumpRightIndex[0].price);
      // console.log(this.dumpLeftIndex[0].price);

      if (!this.dumpRightIndex.length || !this.dumpLeftIndex.length) {
        return 0;
      }
      // if (this.rightIndex == 0) {
      //   console.log(222);
      //   let p = this.dumpLeftIndex[0].price + this.dumpRightIndex[0].price;
      //   return p < 14 ? 0 : p - 14;
      // } else {
      //   console.log(111);
      let p = this.dumpLeftIndex[0].price + this.dumpRightIndex[0].price;
      return p < 12 ? 0 : p - 12;
      // }
    },
  },
  methods: {
    dumpLeftItem(item, index) {
      let src = require(`../products/dl-${index + 1}.png`);
      if (this.dumpLeftImgs.includes(src)) {
        return;
      }

      this.dumpLeftImgs.unshift(src);
      this.dumpLeftIndex.unshift(item);

      this.$nextTick(() => {
        let isBack = false;
        if (this.dumpLeftImgs.length > 1) {
          let isBack = true;
          let dom = $(`#left-${this.dumpLeftIndex[1].index}`);
          let offset = dom.offset();

          TweenMax.fromTo(
            $("#leftdump-" + (this.dumpLeftImgs.length - 1)),
            0.3,
            {
              left: 205,
              top: 70,
              width: 160,
              height: 160,
              opacity: 1,
            },
            {
              left: offset.left,
              top: offset.top,
              width: dom.width(),
              height: dom.height(),
              opacity: 0,
            }
          );
          setTimeout(() => {
            this.dumpLeftImgs.pop();
            this.dumpLeftIndex.pop();
          }, 300);
        }

        this.$nextTick(() => {
          let dom = $(`#left-${index}`);
          let offset = dom.offset();
          TweenMax.fromTo(
            $("#leftdump-" + 0),
            0.3,
            {
              left: offset.left,
              top: offset.top,
              width: dom.width(),
              height: dom.height(),
              ease: Bounce.easeOut,
            },
            {
              left: 205,
              top: 70,
              width: 160,
              height: 160,
              ease: Back.easeOut.config(1.7),
            },
            isBack ? -0.3 : 0
          );
        });
      });
    },
    dumpRightItem(item) {
      let index = item.index;
      this.rightIndex = index;
      if (index !== 0 && !index) {
        return;
      }

      let src = require(`../products/dr-${index + 1}.png`);
      if (this.dumpRightImgs.includes(src)) {
        return;
      }

      this.dumpRightImgs.unshift(src);
      this.dumpRightIndex.unshift(item);

      this.$nextTick(() => {
        let isBack = false;
        if (this.dumpRightImgs.length > 1) {
          let isBack = true;
          let dom = $(`#right-${this.dumpRightIndex[1].index}`);
          let offset = dom.offset();

          TweenMax.fromTo(
            $("#rightdump-" + (this.dumpRightImgs.length - 1)),
            0.3,
            {
              left: 400,
              top: 70,
              width: 160,
              height: 160,
              opacity: 1,
            },
            {
              left: offset.left,
              top: offset.top,
              width: dom.width(),
              height: dom.height(),
              opacity: 0,
            }
          );
          setTimeout(() => {
            this.dumpRightImgs.pop();
            this.dumpRightIndex.pop();
          }, 300);
        }

        this.$nextTick(() => {
          console.log("right-" + index);

          let dom = $(`#right-${index}`);
          console.log(dom);

          let offset = dom.offset();
          TweenMax.fromTo(
            $("#rightdump-" + 0),
            0.3,
            {
              left: offset.left,
              top: offset.top,
              width: dom.width(),
              height: dom.height(),
              ease: Bounce.easeOut,
            },
            {
              left: 400,
              top: 70,
              width: 160,
              height: 160,
              ease: Back.easeOut.config(1.7),
            },
            isBack ? -0.3 : 0
          );
        });
      });
    },
    trigglerPage() {
      this.activeIndex = this.activeIndex === 0 ? 1 : 0;

      if (this.activeIndex === 0) {
        this.dumpLeftImgs = [];
        this.dumpLeftIndex = [];
        this.dumpRightImgs = [];
        this.dumpRightIndex = [];
      }
    },
  },
  created() {
    var view_num = window.screen.availWidth / 750;
    document
      .getElementById("viewport")
      .setAttribute(
        "content",
        "user-scalable=no, width=750, minimum-scale=" +
          view_num +
          ", initial-scale=" +
          view_num +
          ", maximum-scale=" +
          view_num +
          ""
      );
  },
};
</script>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue